export default __webpack_public_path__ + "static/media/img-0805-czech-republic-full-face.51bac40d.png";